import { useState, useEffect } from 'react';
import { picturesAPI } from './services/api';

function EventGalleryModal({ pictures, event, onClose }) {
  const [selectedIndex, setSelectedIndex] = useState(null);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (selectedIndex === null) return;
      if (e.key === 'Escape') setSelectedIndex(null);
      else if (e.key === 'ArrowLeft' && selectedIndex > 0) setSelectedIndex(selectedIndex - 1);
      else if (e.key === 'ArrowRight' && selectedIndex < pictures.length - 1) setSelectedIndex(selectedIndex + 1);
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [selectedIndex, pictures]);

  if (!event) return null;

  const getImageUrl = (picture) =>
    picturesAPI.getImage(picture.picSysName, picture.imageUsername || picture.connectedToUsername);

  if (selectedIndex !== null && pictures[selectedIndex]) {
    const pic = pictures[selectedIndex];
    return (
      <div className="fullscreen-viewer-overlay" onClick={() => setSelectedIndex(null)}>
        <button className="fullscreen-close" onClick={() => setSelectedIndex(null)}>×</button>
        {selectedIndex > 0 && (
          <button className="fullscreen-nav fullscreen-prev" onClick={(e) => { e.stopPropagation(); setSelectedIndex(selectedIndex - 1); }}>
            ‹
          </button>
        )}
        <div className="fullscreen-content" onClick={(e) => e.stopPropagation()}>
          <img src={getImageUrl(pic)} alt={pic.picUserName} className="fullscreen-image" />
          <div className="fullscreen-caption">
            <h3>{pic.picUserName}</h3>
            <p>{pic.connectedToUsername || ''}</p>
            <p className="fullscreen-counter">{selectedIndex + 1} / {pictures.length}</p>
          </div>
        </div>
        {selectedIndex < pictures.length - 1 && (
          <button className="fullscreen-nav fullscreen-next" onClick={(e) => { e.stopPropagation(); setSelectedIndex(selectedIndex + 1); }}>
            ›
          </button>
        )}
      </div>
    );
  }

  return (
    <div className="gallery-modal-overlay" onClick={onClose}>
      <div className="gallery-modal" onClick={(e) => e.stopPropagation()}>
        <div className="dialog-header">
          <h4>{event.name} - Gallery ({pictures.length})</h4>
          <button className="close-dialog" onClick={onClose}>×</button>
        </div>
        {pictures.length === 0 ? (
          <p className="no-gatherings" style={{ padding: '40px 20px' }}>No pictures yet for this event</p>
        ) : (
          <div className="gallery-thumbnails">
            {pictures.map((picture, index) => (
              <div
                key={picture.id}
                className="gallery-thumbnail"
                onClick={() => setSelectedIndex(index)}
              >
                <img
                  src={getImageUrl(picture)}
                  alt={picture.picUserName}
                  className="gallery-thumbnail-image"
                />
                <div className="gallery-thumbnail-info">
                  <p className="thumbnail-caption">{picture.picUserName}</p>
                  <p className="thumbnail-event">{picture.connectedToUsername || 'Event Photo'}</p>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default EventGalleryModal;